<ng-container *ngIf="messages.show">
	<span
		*ngFor="let message of messages?.items; first as isFirst"
		class="d-block fw-regular"
		[ngClass]="{ 'mt-2': !isFirst }"
		[innerHTML]="getI18nString( false, 'messages.' + message?.messageCode, true, message?.spare ?? defaultSpare ) | lineBreakHtmlConverter: 'HTML'"
	></span>
</ng-container>
